import { render, staticRenderFns } from "./tuishuiInvoice.vue?vue&type=template&id=4bb14874&scoped=true"
import script from "./tuishuiInvoice.vue?vue&type=script&lang=js"
export * from "./tuishuiInvoice.vue?vue&type=script&lang=js"
import style0 from "./tuishuiInvoice.vue?vue&type=style&index=0&id=4bb14874&prod&scoped=true&lang=css"
import style1 from "./tuishuiInvoice.vue?vue&type=style&index=1&id=4bb14874&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb14874",
  null
  
)

export default component.exports